import { useCompany } from './useCompany'
import type { AppModule } from '../types/company_member.types'

export type PermissionAction = 'view' | 'create' | 'edit' | 'delete'

export function usePermissions() {
  const { activeCompany } = useCompany()

  function can(module: AppModule, action: PermissionAction): boolean {
    if (!activeCompany) return false

    // Owner and Admin have total access
    if (activeCompany.user_role === 'owner' || activeCompany.user_role === 'admin') return true

    // Check custom permissions if configured
    if (activeCompany.permissions && activeCompany.permissions.length > 0) {
      const p = activeCompany.permissions.find(m => m.module === module)
      if (!p) return false // No permissions for this module at all
      
      switch (action) {
        case 'view': return p.can_view
        case 'create': return p.can_create
        case 'edit': return p.can_edit
        case 'delete': return p.can_delete
      }
    }

    return false
  }

  return { can }
}
